<template>
	<core-layout-content large>
		<core-layout-headline-and-actions>
			<template slot="headline">
				<j-button
					size="small"
					type="secondary"
					@click="$router.back()"
					class="mr2"
				>
					<crm-icon name="back" size="normal" color="c5" class="mr1" />
				</j-button>
				{{ $t("create_pdf_template") }}
			</template>
		</core-layout-headline-and-actions>

		<!-- Body -->

		<j-card class="xs-12 bg5 r2 p4 xs-center">
			<core-form-input
				class="mb4"
				componentName="j-base-input-text"
				name="name"
				id="name"
				:label="$t('name_of_template')"
				:validationErrors="errors"
				v-model="templateName"
				v-validate="{ required: true }"
			/>
			<core-form-input
				class="mb4"
				componentName="j-base-input-long-text"
				name="description"
				id="description"
				:label="$t('description')"
				v-model="templateDescription"
			/>
			<core-form-input
				class="mb4"
				componentName="j-base-select"
				name="templateOptions"
				id="templateOptions"
				:label="$t('template_type')"
				:options="templateOptions"
				v-model="templateType"
			/>
			<div v-if="templateType === 'pdf_drawing'" class="mb4">
				<div class="flex xs-between xs-middle pt2 pb2">
					<span class="fs4 fw7">{{ $t("select_pdf_file") }}</span>
					<j-button
						class="p2"
						size="small"
						type="tertiary"
						@click="$modal.show('upload_pdf')"
						>{{ $t("upload_new_pdf") }}</j-button
					>
				</div>
				<j-base-multi-select-with-flexible-value
					:options="options"
					:placeholder="$t('select_pdf_file')"
					:allowLocalSearch="false"
					:allowMultiSelect="false"
					:isLoading="isLoading"
					valueKey="id"
					nameKey="fileName"
					v-validate="{ required: true }"
					:status="errors.first('file') ? 'error' : null"
					@input="selectedFile = $event"
					@search="searchFilesLocally"
					@focus="fetchUploadedPdfTemplates"
					:value="selectedFile"
				/>
			</div>

			<div class="flex xs-12 xs-right mt4">
				<j-button @click="createTemplate">{{
					$t("create_pdf_template")
				}}</j-button>
			</div>
		</j-card>

		<core-modal name="upload_pdf" :headline="$t('upload_new_pdf')">
			<core-files-upload
				id
				filesOf="template"
				:supportedFileTypes="['pdf']"
				@upload:finished="fetchUploadedPdfTemplates"
			/>
		</core-modal>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreFilesUpload from "@/modules/core/components/CoreFilesUpload"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import api from "../api/"

export default {
	components: {
		JCard,
		JBaseMultiSelectWithFlexibleValue,
		JButton,
		CrmIcon,
		CoreFilesUpload,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreModal,
		CoreFormInput
	},

	data() {
		return {
			templateType: "pdf_drawing",
			templateOptions: [
				{
					name: this.$t("pdf_drawing"),
					value: "pdf_drawing"
				},
				{
					name: this.$t("wkhtml_to_pdf"),
					value: "wkhtml_to_pdf"
				}
			],
			isLoading: false,
			templateName: null,
			templateDescription: null,
			selectedFile: null,
			options: [],
			files: []
		}
	},

	async mounted() {
		await this.fetchUploadedPdfTemplates()
		this.options = this.files.filter(
			item => item.fileName.includes("pdf") || item.fileName.includes("PDF")
		)
	},

	methods: {
		async fetchUploadedPdfTemplates() {
			this.isLoading = true
			const files = await api.listFileTemplates({ prefix: "templates/" })
			this.isLoading = false
			this.files = files?.data?.fileListing?.objectSummaries
			this.options = this.files.filter(
				item => item.fileName.includes("pdf") || item.fileName.includes("PDF")
			)
		},

		searchFilesLocally(searchTerm) {
			this.options = this.files.filter(
				item =>
					(item.fileName.includes(searchTerm) &&
						item.fileName.includes("pdf")) ||
					item.fileName.includes("PDF")
			)
		},

		async createTemplate() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			let apiKey =
				this.templateType === "pdf_drawing"
					? "createPdfDrawingTemplate"
					: "createWkhtmltopdfTemplate"

			let input = {
				name: this.templateName,
				description: this.templateDescription,
				graphQlQuery: ""
			}

			if (this.templateType === "pdf_drawing")
				input.fileKey = `${this.selectedFile[0]?.key}`

			if (this.templateType === "wkhtml_to_pdf") {
				input = {
					...input,
					html: "<p>I am a paragraph</p>",
					marginSettings: { top: 10, right: 0, bottom: 10, left: 0 },
					headerSettings: {
						spacing: 0,
						html: "<!DOCTYPE html><p>I am a header</rp>"
					},
					footerSettings: { spacing: 0, html: "<p>I am a footer</p>" }
				}
			}

			const response = await api[apiKey]({ input })

			if (response?.data?.data?.[apiKey]?.errors) {
				return this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: response?.data?.[apiKey].errors
					}
				})
			}

			// redirect to templateList
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("created_template")
				}
			})

			this.$router.push({ name: "TemplatesList" })
		}
	}
}
</script>
